export default class EmailController {
    constructor($scope, $state, $stateParams, $ionicPopup, ApiEmail, $ionicHistory, FileUploader, localStorageService, $ionicLoading, Restangular, $rootScope) {
        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$ionicHistory = $ionicHistory;
        this.$ionicPopup = $ionicPopup;
        this.$ionicLoading = $ionicLoading;
        this.localStorageService = localStorageService;
        this.ApiEmail = ApiEmail;
        this.files = null;
        this.sending = false;
        this.signature = true;
        this.attachmentSize = 0;
        this.totalFileSize = 0;
        this.to = '';
        this.ccs = '';
        this.Restangular = Restangular;
        this.data = {
            campaign: {
                campaignId: null
            },
            contactExtension: {
                id: null,
                contactInfo: {
                  contact: {
                    id: null,
                    customer: null
                  }
                }
            },
            emailInfo: {
                attachmentInfos: [],
                content: '',
                subject: '',
                toEmails: [],
                ccs: []
            },
            task: {
              taskId: null
            }
        }; // encapsulated data object

        this.populateFromLocalStorage();

        if (this.$stateParams && this.$stateParams.contactExtension) {
            this.to = $stateParams.contactExtension.contactInfo.contact.email;
            this.data.contactExtension.id = $stateParams.contactExtension.id;

            this.data.contactExtension.contactInfo.contact.id = $stateParams.contactExtension.contactInfo.contact.id;
            this.data.contactExtension.contactInfo.contact.customer = $stateParams.contactExtension.contactInfo.contact.customer;

            this.data.campaign.campaignId = $stateParams.campaignId;
            this.data.task.taskId = $stateParams.taskId;
            this.data.emailInfo.toEmails = this.to.split(';');
        }

        // uploading attachments via plugin
        var currentHeaders = {};
        var attachmentUrl = this.Restangular.all('emails').all('attachments').getRestangularUrl();

        currentHeaders.Authorization = 'Bearer ' + localStorageService.get('token');
        this.uploader = new FileUploader({
          url: attachmentUrl,
          headers: currentHeaders
        });

        var attachmentIds = [];

        this.data.emailInfo.attachmentInfos.push(this.uploader.onSuccessItem);

        this.uploader.onSuccessItem = function(fileItem, response, status, headers) {
          attachmentIds.push({ 'id' : parseInt(response[0])});
        };

        this.data.emailInfo.attachmentInfos = attachmentIds;

        this.uploader.onCompleteAll = function() {
          sendEmail();
        };

        var sendEmail = () => {
          this.send();
        };
    }

    init() {
      this.signature = true;
      this.localStorageService.set('emailData', {'to': this.to, 'data': this.data});
    }

    triggerFileInput() {
      document.getElementById('file-input').click();
    }

    getMails() {
        this.ApiEmail.getMails();
    }

    detect() {
        this.showSpinner();
        if (this.uploader.getNotUploadedItems().length) {
            this.uploader.uploadAll();
        } else {
            this.send();
        }
    }

    send() {
        this.showSpinner();
        this.data.emailInfo.ccs = this.ccs.split(';').map(item => item.trim());
        let data = angular.copy(this.data);

        if (this.signature) {
            data.emailInfo.content = data.emailInfo.content.concat('\n\n').concat(this.$rootScope.user.emailSignature);
        }

        this.ApiEmail.sendMail(data).then((result) => {

            this.forceSpinnerClose();
            if (result !== undefined) {

                this.$ionicPopup.alert({
                    title: '<b>Email sent</b>',
                    template: 'Your email has been successfully sent',
                    okType: 'button-picton-blue'

                }).then(() => {
                    if (this.$ionicHistory.backView()) {
                        this.$ionicHistory.goBack();
                    } else {
                        this.$state.go('tasks');
                    }
                });
                this.sending = false;
                this.localStorageService.remove('emailData');
            } else {
                this.$ionicLoading.hide();

            }
        });

    }

    showSpinner() {
        this.loadingCounter = this.loadingCounter || 0;
        this.loadingCounter++;
        this.$ionicLoading.show({ template: '<spinner-advinda></spinner-advinda>' });
    }

    hideSpinner() {
        this.loadingCounter = this.loadingCounter || 0;
        this.loadingCounter--;
        if (this.loadingCounter <= 0) {
            this.$ionicLoading.hide();
        }
    }

    forceSpinnerClose(){
        this.loadingCounter=0;
        this.$ionicLoading.hide();
    }

    addFileSize(fileSize) {
      this.totalFileSize += fileSize;
    }

    reduceFileSize(fileSize) {
      this.totalFileSize -= fileSize;
    }

    populateFromLocalStorage() {
        if (this.localStorageService.get('emailData')) {
            let emailData = this.localStorageService.get('emailData');
            this.to = emailData.to;
            this.data = emailData.data;
        }
    }


}

EmailController.inject = ['$scope', ' $state', '$stateParams', 'ApiEmail', '$ionicHistory', 'Upload', '$timeout', 'FileUploader', 'localStorageService', '$ionicLoading'];



/** WEBPACK FOOTER **
 ** ./src/app/components/email/email.controller.js
 **/